import React from 'react';
import {
  EonAddIcon,
  EonIntroIcon,
  EonSearchIcon,
} from '../../assets/icons/CustomIcons';

export const AboutPage = (
  <div id="aboutpage-wrapper">
    <div className="header-wrapper" id="header-wrapper" />
    <section className="aboutpage-content" id="introduction">
      <h1>
        <EonIntroIcon className="aboutpage-icon" id="intro-icon" />{' '}
        <span>Introduction</span>
      </h1>
      <p>
        The API-Catalog is a searchable internal directory of available APIs at
        E.ON. With the API-Catalog. API owners can actively submit information
        about their APIs to the API catalog (push-strategy).
      </p>
      <p>
        Within the API-Catalog, you can find API information such as functional
        benefits, ownership, or documentation.
      </p>
      <p>
        Whether you're a developer looking for the perfect API to enhance your
        application or an API governor, seeking to get a transparent overview of
        E.ON´s API assets, the API-Catalog offers a user-friendly interface and
        powerful search capabilities to find exactly what you need.
      </p>
      <h3>Key Features:</h3>
      <ul>
        <li>
          <b>API Discovery:</b> Automates process of asset management on APIs
          and improves efficiency
        </li>
        <br />

        <li>
          <b>Transparency:</b> Achieves asset transparency of existing API
          landscape and Gateway environment within E.ON as the Single Source of
          Truth and includes responsible persons (Single Point of Contact) for
          all key stakeholders
        </li>
        <br />
        <li>
          <b>Awareness:</b> Increases visibility of local gateways and potential
          for standardization towards central gateways
        </li>
        <br />
      </ul>
    </section>
    <section className="aboutpage-content" id="add-apis">
      <h1>
        <EonSearchIcon className="aboutpage-icon" id="explore-icon" />
        Explore the API Catalog
      </h1>
      <p>
        The API-Catalog not only lists APIs but also provides essential features
        that empower you to evaluate and understand each API thoroughly.
      </p>
      <h3>Key Exploration Features:</h3>
      <ul>
        <li>
          <b>Fully Functional Swagger Definition:</b> Access complete Swagger
          (OpenAPI) definitions for each API, allowing you to visualize
          endpoints, request/response formats, and authentication methods. This
          interactive documentation makes it easy to understand how to interact
          with the API effectively.
        </li>
        <br />

        <li>
          <b>Comprehensive Technical Documentation:</b> If provided by the API
          owner, the API comes with detailed technical documentation that covers
          everything from setup instructions to advanced usage scenarios. Get
          the information you need to implement APIs confidently and
          efficiently.
        </li>
        <br />

        <li>
          <b>Contact Information:</b> Have questions or need support? Our
          catalog provides direct contact information about the API owner,
          ensuring you can reach out for assistance or clarification whenever
          necessary.
        </li>
        <br />

        <li>
          <b>Search and Filter Options:</b> Quickly find the APIs that meet your
          specific needs with our robust search and filtering capabilities.
        </li>
        <br />
      </ul>
    </section>
    <section className="aboutpage-content" id="add-apis">
      <h1>
        <EonAddIcon className="aboutpage-icon" id="add-icon" />
        Contribute to the API-Catalog
      </h1>
      <p>
        We offer different options for API owners to contribute by adding their
        own API to our growing catalog.
      </p>
      <h3>Add Your API with Ease:</h3>
      <ul>
        <li>
          <b>GitLab Pipeline Extension:</b> Integrate your API directly into the
          API-Catalog using our GitLab pipeline extension. This feature allows
          you to automate the process of adding and updating your API
          definitions, ensuring that your API is always up-to-date with the
          latest information. Simply configure the pipeline, and let it handle
          the rest!
        </li>
        <br />
        <li>
          <b>API Endpoint for Submissions:</b> Prefer a more direct approach?
          Use our dedicated API endpoint to submit your API manually. This
          option provides flexibility for API owners who want to add or update
          their APIs on-the-fly. With clear documentation and guidelines, you
          can easily submit all necessary details, including metadata,
          documentation links, and contact information.
        </li>
        <br />
      </ul>
      <p>
        By contributing to the API-Catalog, you not only enhance the resource
        for others but also increase the visibility of your APIs within the
        developer community. Join us in building a comprehensive and
        collaborative API ecosystem by writing an email to{' '}
        <a href="mailto:api-catalog@eon.com">api-catalog@eon.com</a>.
      </p>
    </section>
  </div>
);
